import { render, staticRenderFns } from "./crudeoil.vue?vue&type=template&id=6e193a20&scoped=true&"
import script from "./crudeoil.vue?vue&type=script&lang=js&"
export * from "./crudeoil.vue?vue&type=script&lang=js&"
import style0 from "./crudeoil.vue?vue&type=style&index=0&id=6e193a20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e193a20",
  null
  
)

export default component.exports